export default __webpack_public_path__ + "static/media/icon-right-dark.d47f2bdb.svg";